import React from 'react'
import Homepage from './components/homepage/homepage'
import './App.sass'
import Nav from './components/nav/nav'

function App() {
  return (
    <>
      <Nav />
      <Homepage />
    </>
  )
}

export default App